/** @module ProductSpec/SizeChart/ProductGroupController */
define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi/_base/underscore",
	"csi/action/ActionView",
    "csi/comm/PostRequest",
	"csi/def",
	"csi/action/Controller",
	"csi/xml"
], function(declare,lang,_,ActionView,PostRequest,def,Controller,xml) {
	const CSS_ATTR = "_CSS";

	/**
	 * This module is action controller for
	 * ProductSpec.xml
	 * Node = SizeChartRevision
	 * Heading Id="Group"
	 * View Widget = "ProductSpec/SizeChart/ProductGroupView"
	 * UI Path: Home/Styles/Style->Style/Specification/SizeChart->SizeChart/Properties -> "Product Group" tooltip "Edit"
	 */

	return declare(Controller, {

		/**
		 * @override
		 * Initialize the view
		 */
		getActionView: function(vr) {
			const node = this.getNode() || this.getParent();
			const defView = def.getNodeViewDef(node, "ProductGroup");

			return new ActionView(this, defView, node);
		},


		toWriter: function() {

			const call = this.inherited(arguments); // csi/xml/CallMethod

			const {
				newProductGroup,
				maintainTolerances,
				maintainDimensions,
			} = this.popupView;

			call.addParameter("URL", xml.ATTR_REF, this.getNodeURL() || this.getParentURL());
			call.addParameter("ProductGroup", xml.ATTR_REF, newProductGroup);
			call.addParameter("MaintainTolerances", xml.ATTR_BOOLEAN, maintainTolerances);
			call.addParameter("MaintainDimensions", xml.ATTR_BOOLEAN, maintainDimensions);
		}

	});
});